@if(component){

<text class="block wrap"
      [content]="component"></text>

<!-- slider -->
<carousel class="default-swiper swiper-slide-per-view default-pagination swiper-show-outside-wrap wrap m-t-8"
          [slidesPerView]="'auto'"
          [style.--pc-slides-ceil]="pcSlidesCeil"
          [style.--pc-slides]="pcSlides"
          [style.--pc-gutter]="pcGutter"
          [navigation]="client.isX || client.isL ? true : false"
          [scrollbar]="true"
          [freeMode]="true"
          imageViewRoot>
    @for(slide of component.links; track $index){
    <ng-template swiperSlide>
        <href [link]="!slide.trayProducts && slide.link"
              class="ratio-1-1 overflow-hidden block">
            <shell></shell>
            <img [fill]="true"
                 [ratio]="1"
                 [dfImage]="slide.image">

            <div class="pos-absolute bottom-2 left-2">
                <button (click)="openTray(slide)"
                        [iconButton]="'filled-dark'"
                        [textAnimated]="'Shop the Look' | translate"
                        [status]="trayOpenStatus.get(slide)"
                        [icon]="'basket'"
                        class="inline-flex"></button>
            </div>

        </href>

        <href [link]="slide.link">
            <div class="p2 col-12 m-t-1"
                 *iCms="'tagName' of slide; content: 'basicHtml'"></div>
        </href>

    </ng-template>
    }
</carousel>
}
